export enum DateFormat {
  YYYY_MM_DD = 'yyyy-MM-dd',
  DD_MM_YYYY = 'dd.MM.yyyy',
  MM_YYYY = 'MM.yyyy',
  ISO = "yyyy-MM-dd'T'HH:mm:ss'Z'",
}
